// import { Divider } from 'primereact/divider';
// import { Toolbar } from 'primereact/toolbar';
// import { Dialog } from 'primereact/dialog';
// import ShareComponent from '../Share/share.component';
// import LoadingSpinner from '../loading-spinner/loading-spinner';
// import { SpecialZoomLevel, ViewMode, Viewer } from '@react-pdf-viewer/core';
// import { Worker } from '@react-pdf-viewer/core';
// import {installPWA, onClickInstallButton, pwaInstalled} from "../../utilityPWA";
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import React, { useEffect, useRef, useState } from 'react';
import { Password } from 'primereact/password';
import { goTo } from '../../utilities/common.utilities';
import { getUser } from '../../service/login.service';
import './login.css'
import { Toast } from 'primereact/toast';
import PopupInstallComponent from '../PopupInstall/popupInstall.component';
import FooterPreLoginComponent from '../Footer/footer-pre-login.component';
import { useConnectivity } from '../../context/connectivityContext';

export default function LoginComponent() {
    // const [showSharingComponent, setShowSharingComponent] = useState<boolean>(false);
    // const [showTermsOfUse, setShowTermsOfUse] = useState<boolean>(false);
    
    const toast = useRef<Toast>(null);

    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const passwordRef = useRef<HTMLInputElement | null>(null);

    const [showPopupInstall, setShowPopupInstall] = useState<boolean>(false);
    const { isOnline } = useConnectivity();

    const login = () => {

      if(username && password) {

        getUser(username, password).then((data: any)=> {
            if(data?.status === 500) {
                toast.current?.show(
                    { 
                        severity: 'error',
                        summary: 'Errore',
                        detail: data.message || 'Si è verificato un errore'
                    }
                );
            }
        })

      }   

    };

    useEffect(() => {}, [isOnline]) // Indico di reindirizzare il componente quando la variabile isOnline cambia valore
    useEffect(() => { 
        if (passwordRef.current) { 
            passwordRef.current.setAttribute("autocomplete", "current-password"); 
        }
    }, []); 

    return (
        <>
        <Toast ref={toast} position="top-center"/>
        <PopupInstallComponent openManually={true} showBehaviorManually={showPopupInstall} 
            onClosePopup={() => {
                if(showPopupInstall) {
                    setShowPopupInstall(false)
                }}
            }
        />
        
        <div className='header-login background-header-login'>
            <div className="flex justify-content-center ">

                {
                    process.env.REACT_APP_SUFFIX_TITLE_HEADER
                    ?
                        <div className='flex justify-content-center align-items-center mt-2 '>
                            <img src="/new_icons/MySalusAPP_PITTOGRAMMA_WHITE.svg" alt="" className='logo-login mr-2'/>

                            <div className='flex flex-column '>
                                <h1 className="mb-0 title-login " style={{ marginTop: '0.8rem' }}>
                                    MySalusApp
                                </h1>

                                <div className="flex justify-content-end text-sm ">
                                    <div className="flex align-items-center justify-content-center title-login">
                                        {process.env.REACT_APP_SUFFIX_TITLE_HEADER}
                                    </div>
                                </div>
                            </div>

                        </div>
                    :
                    <div className='flex justify-content-center align-items-center'>
                        <img src="/new_icons/MySalusAPP_PITTOGRAMMA_WHITE.svg" alt="" className='logo-login mr-2 mt-3'/>
                        <h1 className="mb-2 title-login">
                            MySalusApp
                        </h1>
                    </div>
                }
                {/* <img src="MYSALUS_APP_LOGO-TEXT_DIM2.svg" alt="" className='logo-login mt-3' /> */}

            </div>
        </div>
        <div className='content-login login-class'> 
            <div className="flex flex-column gap-5">{/*md:flex-row*/}
                <form action="" method="" noValidate className="w-full flex flex-column align-items-center justify-content-center gap-5 py-5">{/*md:w-5 */}
                    
                    
                    <div className="flex flex-wrap justify-content-center align-items-center gap-5 w-full">
                        <span className="p-float-label" style={{width: '75%'}}>
                            <InputText style={{width:'100%'}} id="username" name="username" autoComplete="on" value={username} tabIndex={2}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setUsername(e.target.value)} /> 
                            <label className='loginLabel' htmlFor="username">Username</label>
                        </span>
                    </div>

                    
                    <span className="p-float-label" style={{width: '75%'}}>
                        <Password inputStyle={{width: '100%'}} 
                            id="password" name="password"
                            value={password}
                            // inputRef={ref => ref?.setAttribute('tabIndex','3')}
                            inputRef={ref => { 
                                if (ref) { 
                                    ref.setAttribute('tabIndex', '3'); 
                                    ref.setAttribute('autocomplete', 'current-password'); 
                                } 
                            }} 
                            onChange={(e) => setPassword(e.target.value)} toggleMask feedback={false} />
                        <label className='loginLabel' htmlFor="password">Password</label>
                    </span>

                    <div className="flex flex-row"> {/*style={{width: '75%'}}*/}
                        <p className="text-forgot-password mt-0"
                            style={{cursor:'pointer'}}
                            onClick={() => { goTo('/forgot-password') }}>
                            Password dimenticata?
                        </p>
                    </div>

                    <div>

                        <Button type="submit" id='login' onClick={(e) => { e.preventDefault(); login() }} label="Accedi" disabled={(username && password) ? false : true} style={{borderRadius: '24px'}} className="w-20rem mx-auto">
                            
                        </Button>

                        <div className="flex flex-row align-items-center justify-content-center gap-3 content-alternative-login-signup">
                            <div className="mt-1 border-top-1 flex-grow-1"></div>
                            <p className="flex-none flex">Oppure</p>
                            <div className="mt-1 border-top-1 flex-grow-1"></div>
                        </div>

                        <Button type="button" id='signup' onClick={()=>{goTo('/signup')}} label="Registrati" style={{borderRadius: '24px'}} className="w-20rem mx-auto">
                        </Button>

                    </div>
                    
                </form>
                    
                
            </div>
        </div>
        
        <FooterPreLoginComponent />
        </>
        
    )
}